// echarts 分析模块 图表封装
import echarts from "echarts";
import util from "@/utils.js";
import {
    HistogramChartsColor,
    HistogramTop4,
    AreaColor,
    ColumnLineColor,
    MultiLineColor,
    MultiHistogramColor
} from './theme'

/**
 * 可拖动柱状图 显示百分比 鼠标悬停显示数量
 * @param {*id} id
 * @param {*数据 data legend} result
 * @param {*是否显示百分比 true 不显示} showPercent
 */
const draggableHistogramCharts = (id, result, showPercent,num) => {
    // let AllNumCount = 0
    // data.data.forEach(item => {
    //     for(let obj in item) {
    //         legend_tmp.push(obj)
    //         arrydata.push(item[obj])
    //         AllNumCount+= Number(item[obj])
    //     }
    // })
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        dataZoom: [{
            type: 'inside',
            startValue: 0, //可视区域显示的柱状图个数范围
            endValue: num || 5,
        }, {
            type: 'slider',
            borderColor: 'transparent',
            handleSize: 0,
            bottom: '8%',
            backgroundColor: 'transparent',
            height: '10px',
            zoomLock: true,
            textStyle: {
                color: 'transparent'
            },
            dataBackground: {
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: 'transparent'
                }
            }

        }],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(0,0,0,0.05)',
                    borderRadius: '5px',
                }
            },
            formatter: (data) => {
                return '<div style="line-height: 22px">' + data[0].name + '</div>' +
                    '<div style="font-weight: bold;line-height: 22px">人数：' + util.showThousandNumber(data[0].value) + ' 人</div>';
            }
        },
        grid: {
            left: '2%',
            right: '3%',
            bottom: '10%',
            top: '8%',
        },
        xAxis: [{
            show: true,
            type: 'category',
            data: result.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        }],
        yAxis: {
            show: true,
            type: 'value',
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            }
        },
        series: [{
                name: '人数',
                stack: '人数',
                type: 'bar',
                // color: '#8A94A6',
                color: '#FBBE02',
                barWidth: '20',
                data: result.data,
                itemStyle: {
                    // barBorderRadius: [2, 2, 0, 0],
                    normal: {
                        barBorderRadius: [2, 2, 0, 0],
                        color: HistogramChartsColor,
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'black',
                                fontSize: 12
                            },
                            formatter: (params) => {
                                if (showPercent) {
                                    return
                                } else {
                                    return (
                                        result.data.find((item) => {
                                            return item.name == params.name
                                        }).percent + "%"
                                    );
                                }

                            },
                        }
                    },
                },
                emphasis: { //鼠标移上去 柱子的颜色
                    itemStyle: {
                        // color: "#FBBE02"
                    }
                }
            },
            // {
            //     name: '人数占比',
            //     stack: '人数',
            //     type: 'bar',
            //     barWidth: '16',
            //     color: 'transparent',
            //     data: data.y2data,
            //     itemStyle: {
            //         barBorderRadius: [2, 2, 0, 0]
            //     },
            //     label: {
            //         show: true,
            //         color: '#000000',
            //         position: 'top',
            //         fontSize: 12,
            //         fontWeight: 500,
            //         lineHeight: 7,
            //         formatter: function (data) {
            //             return data.data + "%"
            //         }
            //     }
            // }
        ]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}


/**
 * 显示最大值最小值
 * 间隔显示x轴interval
 */
const IntervalMaxMinHistogramCharts= (id, result,interval) =>{
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(0,0,0,0.05)',
                    borderRadius: '5px',
                }
            },
            formatter: (data) => {
                return '<div style="line-height: 22px">' + data[0].name + '</div>' +
                    '<div style="font-weight: bold;line-height: 22px">人数：' + util.showThousandNumber(data[0].value) + ' 人</div>';
            }
        },
        grid: {
            left: '-4%',
            right: '3%',
            bottom: '0%',
            top: '7%',
            containLabel: true
        },
        xAxis: [{
            show: true,
            type: 'category',
            data: result.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval,
                color: '#8A94A6'
            },
        }],
        yAxis: {
            show: true,
            type: 'value',
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            }
        },
        series: [{
                name: '人数',
                stack: '人数',
                type: 'bar',
                color: HistogramChartsColor,
                barWidth: '20',
                data: result.data,
                markPoint : {
                    data : [
                        {type : 'max', name: '最大值'},
                        {type : 'min', name: '最小值'}
                    ],
                    symbolSize:' [20, 20]',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#000',
                        fontSize: 11,
                    }
                }
            }
        ]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}
/**
 * 显示最大值最小值
 * 间隔显示x轴interval
 * 显示
 * unit % 显示
 */
const IntervalMaxMinMarkLineHistogramCharts = (id, result, markLineyAxis,interval,unit) => {
    let myChart = echarts.init(document.getElementById(id))
    let tooltipUnit = unit || ''
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(0,0,0,0.05)',
                    borderRadius: '5px',
                }
            },
            formatter: (data) => {
                let resultData = data[0]
                let result = ''
                if(tooltipUnit) {
                    result = '<span style="line-height: 22px">' + resultData.name + "："+'</span>' +
                    '<span style="font-weight: bold;line-height: 22px">' + resultData.value + tooltipUnit +'</span>';
                } else {
                    result = '<span style="line-height: 22px">' + resultData.name+ "："+'</span>' +
                    '<span style="font-weight: bold;line-height: 22px">' + util.showThousandNumber(resultData.value) + '</span>';
                }
                return result
            }
        },
        grid: {
            left: '-4%',
            right: '4%',
            bottom: '0%',
            top: '7%',
            containLabel:true
        },
        xAxis: [{
            show: true,
            type: 'category',
            data: result.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval,
                color: '#8A94A6'
            },
        }],
        yAxis: {
            show: true,
            type: 'value',
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            }
        },
        series: [{
            name: '',
            stack: '人数',
            type: 'bar',
            // color: '#8A94A6',
            color: HistogramChartsColor,
            barWidth: '14',
            data: result.data,
            markPoint : {
                data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                ],
                symbolSize:' [20, 20]',
                label: {
                    show: false,
                    position: 'top',
                    color: '#000',
                    fontSize: 9,
                }
            },
            markLine: {
                silent: true,
                symbol : [ 'none', 'none' ],//去掉箭头
                lineStyle : {
                    normal : {
                        type: 'dashed',
                        color : '#ADADAD',
                        width : 2
                        // 这儿设置安全基线颜色
                    }
                },
                data : [
                    {
                        yAxis : markLineyAxis,
                        name : 'KPI',
                        label: {
                        padding: [-13, -20, 5, -45],  // 重点在这里，这个地方就是定位
                        position: 'end',
                        }
                    }
                ],
                label : {
                    // show: true,
                    normal : {
                        textStyle : {
                            color : '#000',
                            fontSize: 12,
                            fontWeight: 'bold'
                        },
                        formatter: () => {
                            // param.name+ '\n '+ param.value
                            return markLineyAxis
                        }

                    },
                }
            }
        }, ]
    }

    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

/**
 * 显示百分比 鼠标悬停显示数量
 * @param {*id} id
 * @param {*数据 data legend} result
 * @param {*是否显示百分比 true 不显示} showPercent
 */
 const HistogramCharts = (id, result, showPercent) => {
    // let AllNumCount = 0
    // data.data.forEach(item => {
    //     for(let obj in item) {
    //         legend_tmp.push(obj)
    //         arrydata.push(item[obj])
    //         AllNumCount+= Number(item[obj])
    //     }
    // })
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(0,0,0,0.05)',
                    borderRadius: '5px',
                }
            },
            formatter: (data) => {
                return '<div style="line-height: 22px">' + data[0].name + '</div>' +
                    '<div style="font-weight: bold;line-height: 22px">人数：' + util.showThousandNumber(data[0].value) + ' 人</div>';
            }
        },
        grid: {
            left: '2%',
            right: '3%',
            bottom: '10%',
            top: '8%',
        },
        xAxis: [{
            show: true,
            type: 'category',
            data: result.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        }],
        yAxis: {
            show: true,
            type: 'value',
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            }
        },
        series: [{
                name: '人数',
                stack: '人数',
                type: 'bar',
                // color: '#8A94A6',
                color: '#FBBE02',
                barWidth: '20',
                data: result.data,
                itemStyle: {
                    // barBorderRadius: [2, 2, 0, 0],
                    normal: {
                        barBorderRadius: [2, 2, 0, 0],
                        // color: "#FBBE02",
                        color: HistogramChartsColor,
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'black',
                                fontSize: 12
                            },
                            formatter: (params) => {
                                if (showPercent) {
                                    return
                                } else {
                                    return (
                                        result.data.find((item) => {
                                            return item.name == params.name
                                        }).percent + "%"
                                    );
                                }

                            },
                        }
                    },
                },
                emphasis: { //鼠标移上去 柱子的颜色
                    itemStyle: {
                        // color: "#FBBE02"
                    }
                }
            },
            // {
            //     name: '人数占比',
            //     stack: '人数',
            //     type: 'bar',
            //     barWidth: '16',
            //     color: 'transparent',
            //     data: data.y2data,
            //     itemStyle: {
            //         barBorderRadius: [2, 2, 0, 0]
            //     },
            //     label: {
            //         show: true,
            //         color: '#000000',
            //         position: 'top',
            //         fontSize: 12,
            //         fontWeight: 500,
            //         lineHeight: 7,
            //         formatter: function (data) {
            //             return data.data + "%"
            //         }
            //     }
            // }
        ]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

/**
 * 效果看板 Lift per mem
 * 可拖动柱状图 显示数量和markLine 鼠标悬停显示数量
 * @param {*id} id
 * @param {*数据 data legend} result
 * @param {*markLineyAxis kpi} markLineyAxis
 */
const MarkLineHistogramCharts = (id, result, markLineyAxis) => {
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        dataZoom: [{
            type: 'inside',
            startValue: 0, //可视区域显示的柱状图个数范围
            endValue: 4,
        }, {
            type: 'slider',
            borderColor: 'transparent',
            handleSize: 0,
            bottom: '8%',
            backgroundColor: 'transparent',
            height: '10px',
            zoomLock: true,
            textStyle: {
                color: 'transparent'
            },
            dataBackground: {
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: 'transparent'
                }
            }

        }],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(0,0,0,0.05)',
                    borderRadius: '5px',
                }
            }
        },
        grid: {
            left: '2%',
            right: '7%',
            bottom: '10%',
            top: '8%',
        },
        xAxis: [{
            show: true,
            type: 'category',
            data: result.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        }],
        yAxis: {
            show: true,
            type: 'value',
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            }
        },
        series: [{
            name: '人数',
            stack: '人数',
            type: 'bar',
            // color: '#8A94A6',
            color: '#FBBE02',
            barWidth: '20',
            data: result.data,
            itemStyle: {
                // barBorderRadius: [2, 2, 0, 0],
                normal: {
                    barBorderRadius: [2, 2, 0, 0],
                    color: "#FBBE02",
                    label: {
                        show: true, //开启显示
                        position: 'top', //在上方显示
                        textStyle: { //数值样式
                            color: 'black',
                            fontSize: 12
                        },
                        formatter: (params) => {
                            return
                        },
                    }
                },
            },
            markLine: {
                silent: true,
                symbol: ['none', 'none'],
                itemStyle: {
                    normal: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#0E254D',
                        },
                        label: {
                            show: true,
                            position: 'end',
                            distance: 0,
                            textStyle: {
                                color: '#F84635',
                                fontSize: 9,
                                // fontWeight: 'bold'
                            }
                        }
                    }
                },
                data: [{
                    yAxis: markLineyAxis,
                }],
                label: {
                    normal: {
                        show: true
                    }
                }
            }
        }, ]
    }

    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}
/**
 * 环形饼图
 * @param {*id} id
 * @param {*数据[{name:'xx', value:100},...]} data
 */
const RingPieCharts = (id, chartData) => {
    let myChart = echarts.init(document.getElementById(id))
    let color = [ HistogramChartsColor, '#919191', '#777','#000000',];
    let arrName = [];
    let arrValue = [];
    let sum = 0;
    let pieSeries = [],
        lineYAxis = [];

    // 数据处理
    chartData.forEach((v, i) => {
        arrName.push(v.name);
        arrValue.push(v.value);
        sum = sum + v.value;
    })

    // 图表option整理
    chartData.forEach((v, i) => {
        let chartnewData = chartData.slice(0, i)
        let newValue = chartnewData.reduce((a, b) => {
            return a + b.value
        }, 0)
        v.startAngle = newValue / sum * 360
        pieSeries.push({
            name: '学历',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            radius: [75 - i * 15 + '%', 68 - i * 15 + '%'],
            center: ["30%", "44%"],
            label: {
                show: false
            },
            startAngle: v.startAngle + 90,
            data: [{
                value: v.value,
                name: v.name
            }, {
                value: sum - v.value,
                name: '',
                itemStyle: {
                    color: "rgba(0,0,0,0)"
                }
            }]
        });
        pieSeries.push({
            name: '',
            type: 'pie',
            silent: true,
            z: 1,
            clockWise: false, //顺时加载
            hoverAnimation: true, //鼠标移入变大
            radius: [75 - i * 15 + '%', 68 - i * 15 + '%'],
            // radius: ['50%', '70%'],
            center: ["30%", "44%"],
            label: {
                show: false
            },
            data: [{
                    value: sum,
                    itemStyle: {
                        color: "#F7F8F9" //圆环颜色
                    }
                },
                {
                    value: 0,
                    name: '',
                    itemStyle: {
                        color: "red"
                    }
                }
            ]
        });
        v.percent = (v.value / sum * 100).toFixed(0) + "%";
        lineYAxis.push({
            value: i,
            textStyle: {
                rich: {
                    circle: {
                        color: color[i],
                        padding: [0, 5]
                    }
                }
            }
        });
    })
    let option = {
        color: color,
        tooltip: {
            formatter: (data) => {
                if(data.name) {
                    return '<div style="line-height: 22px">' + data.name + '</div>' +
                    '<div style="font-weight: bold;line-height: 22px">人数：' + util.showThousandNumber(data.value) + ' 人</div>';
                }  
            },
        },
        legend: {
            selectedMode: false,
            icon: 'circle',
            show: true,
            left: "60%",
            top: "20%",
            itemGap: 2,
            formatter: (name) => {
                return (
                    "{name|" + name + "} \n{percent|" + chartData.find((item) => {
                        return item.name == name
                    }).percent + "}"
                );
            },
            textStyle: {
                color: "#beceff", //元字颜色
                fontSize: 12,
                rich: {
                    name: {
                        color: '#0E254D',
                        fontSize: 12,
                    },
                    percent: {
                        color: '#919191',
                        lineHeight: 20,
                        fontSize: 12,
                    }
                }
            },
        },
        grid: {
            top: '0%',
            bottom: '20%',
            left: "0%",
            containLabel: false
        },
        yAxis: [{
            type: 'category',
            inverse: false,
            axisLine: {
                show: false
            },
            axisTick: {
                show: true
            },
            axisLabel: {
                show: false
            },
            data: lineYAxis
        }],
        xAxis: [{
            show: false
        }],
        series: pieSeries
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

/**
 * 横向树状图 top4
 * @param {*id} id
 * @param {*数据} data
 */
const HorizontalHistogramTop4 = (id, echartData) => {
    let myChart = echarts.init(document.getElementById(id))
    let attackSourcesColor = HistogramTop4

    let max = 0
    if(echartData.length >0) {
        parseInt(echartData[0].value)
        for (let i = 0; i < echartData.length - 1; i++) {
            // max = max < parseInt(echartData[i + 1].value) ? parseInt(echartData[i + 1].value) : max
            max += parseInt(echartData[i].value)
        }
    }
    let option = {
        tooltip: {
            // show: false,
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(150,150,150,0.1)'
                }
            },
            formatter(params) {
                for (var i = 0; i < params.length; i++) {
                    return params[i].name + ":" + '<br/>' +
                        "人数:" + util.showThousandNumber(params[i].data.value) + '<br/>' +
                        "占比:" + echartData.find((item) => {
                            return item.name == params[i].name
                        }).percent + '%';
                }
            }
        },
        legend: {
            show: false
        },
        grid: {
            top: '7%',
            bottom: 0,
            left: '-6%',
            right: '-14%',
            containLabel: true
        },
        xAxis: {
            show: false,
            type: 'value'
        },
        yAxis: [{
                type: 'category',
                inverse: true,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                data: echartData.map(item => item.name),
                axisLabel: {
                    // show: false,
                    margin: 0,
                    fontSize: 12,
                    align: 'left',
                    color: '#000000',
                    padding: [0, 0, 30, 0],
                    interval: 0,
                    rich: {
                        a1: {
                            color: '#000000',
                            fontSize: 12,
                        },
                        a2: {
                            color: '#000000',
                        },
                        a3: {
                            color: '#000000',
                        },
                        b: {
                            color: '#000000',
                        }
                    },
                    formatter: function (params) {
                        var index = echartData.map(item => item.name).indexOf(params);
                        index = index + 1;
                        if (index - 1 < 3) {
                            return [
                                '{a' + index + '|' + index + '}' + '、' + params
                            ].join('\n')
                        } else {
                            return [
                                '{b|' + index + '}' + '  ' + params
                            ].join('\n')
                        }
                    }
                }
            },
            {
                triggerEvent: true,
                show: true,
                inverse: true,
                data: echartData.map(item => item.value),
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    interval: 0,
                    // shadowOffsetX: '-60px',
                    color: '#8A94A6',
                    align: 'right',
                    verticalAlign: 'bottom',
                    lineHeight: 30,
                    fontSize: 12,
                    padding: [0, 30, 0, 0],
                    formatter: (value,index) => {
                        // return util.showThousandNumber(value) // 数值显示
                        return echartData[index].percent + "%"
                    }
                }
            }
        ],
        series: [{
                z: 2,
                name: 'value',
                type: 'bar',
                barWidth: 5,
                itemStyle: {
                    barBorderRadius: [4, 0, 0, 4]
                },
                zlevel: 1,
                data: echartData.map((item, i) => {
                    let itemStyle = {
                        color: i > 3 ? attackSourcesColor[3] : attackSourcesColor[i]
                    }
                    return {
                        value: item.value,
                        itemStyle: itemStyle
                    };
                }),
                label: {
                    show: false,
                    position: 'right',
                }
            },
            {
                name: '背景',
                type: 'bar',
                barWidth: 5,
                barGap: '-100%',
                itemStyle: {
                    normal: {
                        color: '#E1E4E8'
                    }
                },
                data: (new Array(echartData.length)).fill(max),
            }
        ]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}
/**
 * 面积折线图 购买时段偏好
 * @param {*} id
 * @param {* data ,xData} data
 */
const AreaLineChart = (id, list) => {
    let array = list
    let data = [];
    let xData = [];
    array.forEach(item=>{
       data.unshift(item.value)
       xData.unshift(item.name)
    })
    let myChart = echarts.init(document.getElementById(id))
    // let data = [20, 30, 40, 60, 50, 30, 30];
    // let xData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    let option = {
        grid: {
            left: '7%',
            right: '6%',
            top: '10%',
            bottom: '18%',
        },
        legend: {
            show: false,
            data: ['a'],
            textStyle: {
                color: '#FBBE02',
            },
            orient: 'horizontal',
            icon: 'rect',
            top: '5',
            right: '5%',
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 7,
        },
        tooltip: {
            trigger: 'axis',
            formatter(params) {
                for (var i = 0; i < params.length; i++) {
                    let name = params[i].name
                    let itemD = array.filter(item => item.name === name)
                    let percent = itemD[i].percent
                    return name + ":" + util.showThousandNumber(params[i].value)+ '<br/>' +
                        "占比:" + percent + "%"
                }
            },
            axisPointer: {
                type: 'line',
                lineStyle: {
                    color: 'rgba(145,145,145,.4)',
                },
            },
        },
        xAxis: {
            type: 'category',
            boundaryGap: false, //顶头显示
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                },
            },

            axisTick: {
                show: false,
                // alignWithLabel: true,
                lineStyle: {
                    color: '#3585d5',
                },
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                fontSize: 12,
                interval: 0,
                formatter: (params) => {
                    let newParamsName = ""
                    let params1 = params.indexOf(" ")
                    let params2 = params.indexOf("-")
                    let length = params.length
                    if (params1 > 0) {
                        let a = params.indexOf(' ')
                        newParamsName = params.substring(0, a) + "\n" + params.substring(a + 1, length)
                    } else if (params2 > 0) {
                        let a = params.indexOf('-')
                        newParamsName = params.substring(0, a) + "\n" + params.substring(a, length)
                    } else {
                        newParamsName = params
                    }
                    return newParamsName
                },
                color: '#8A94A6'
            },
            data: xData,
        },
        yAxis: {
            name: '',
            type: 'value',
            axisLine: {
                show: false,
                lineStyle: {
                    color: '#3585d5',
                },
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                },
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: false,
                fontSize: 12,
            },
            boundaryGap: false,
        },
        series: [{
            name: 'a',
            type: 'line',
            stack: '总量',
            smooth: true,
            symbol: 'none',
            showSymbol: true,
            symbolSize: 80,
            itemStyle: {
                normal: {
                    color: '#71bd27',
                    lineStyle: {
                        color: '#FBBE02',
                        width: 1,
                    },
                    areaStyle: {
                        opacity: 1,
                        // color: '#FBBE02'
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                            {
                                offset: 0.1,
                                color: AreaColor[1],
                            },
                            {
                                offset: 1,
                                color: AreaColor[0],
                            },
                        ]),
                    },
                },
            },
            markPoint: {
                itemStyle: {
                    normal: {
                        color: 'transparent',
                        label: {
                            show: true,
                            color: '#000000',
                            formatter: (param) => {
                                let index = param.data.coord[0]
                                let newArray = []
                                array.forEach(item=>{
                                    newArray.unshift(item)
                                })
                                return newArray[index].percent+"%"
                            }
                        }
                    }
                },
                data: [{
                    type: "max",
                    name: "最大值",
                    symbol: "rect",
                    symbolSize: [25, 25], // 容器大小
                    symbolOffset: [0, -12], //位置偏移

                }]
            },
            data,
        }, ],
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

/**
 * 柱状图（数量）& 折线图（百分比）
 * @param {*echarts的id} id
 * @param {* legend(x), y1data, y2data} data
 * @param {*图例数组} legend
 */
const ColumnLineChart = (id, data, legend) => {
    let dataPercent = data.dataPercent
    let dataValue = data.dataValue
    let y1data = []
    dataValue.forEach(item => {
        y1data.push(item.value)
      })
    let y2data = []
    dataPercent.forEach(item => {
        y2data.push(item.value)
      })
    let newlegend = data.legend
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        // dataZoom: [{
        //     type: 'inside',
        //     startValue: 0, //可视区域显示的柱状图个数范围
        //     endValue: 7,
        // }, {
        //     type: 'slider',
        //     borderColor: 'transparent',
        //     handleSize: 0,
        //     bottom: '8%',
        //     backgroundColor: 'transparent',
        //     height: '10px',
        //     textStyle: {
        //         color: 'transparent'
        //     },
        //     dataBackground: {
        //         lineStyle: {
        //             color: '#f5f5f5'
        //         },
        //         areaStyle: {
        //             color: '#f5f5f5'
        //         }
        //     }

        // }],
        grid: {
            top: '13%',
            left: '3%',
            right: '2%',
            bottom: '0%',
            containLabel: true,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
            formatter(params) {
                let data = '';
                for (var i = 0; i < params.length; i++) {
                    if (params[i].seriesName == legend[1]) {
                        data += params[i].seriesName + ':  ' + params[i].value + '%';
                    } else {
                        data += params[i].axisValueLabel + '<br/>' + params[i].seriesName + ':  ' + params[i].value + '<br/>';
                    }
                }
                return data;
            },
        },
        legend: {
            data: legend,
            top: 'top',
            right: '0%',
            itemWidth: 14,
            itemHeight: 10, // 修改icon图形大小
            textStyle: {
                color: '#000000',
            },
        },
        xAxis: {
            type: 'category',
            data: newlegend,
            axisLine: {
                show: false,
                // lineStyle: {
                //     color: 'rgba(241, 242, 244, 1)'// tooltip的框颜色
                // }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                textStyle: {
                    color: '#8A94A6', //X轴文字颜色
                },
            },
        },
        yAxis: [{
                type: 'value',
                name: '', //单位
                nameTextStyle: {
                    color: '#393939',
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgba(241, 242, 244, 1)'
                    },
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: { //y1坐标轴文字
                    show: false,
                    textStyle: {
                        color: '#393939',
                    },
                },
            },
            {
                type: 'value',
                name: '', // 单位
                nameTextStyle: {
                    color: '#393939',
                    padding: [0, 0, 0, 40], // 四个数字分别为上右下左与原位置距离
                },
                position: 'right',
                splitLine: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    show: false,
                    textStyle: {
                        color: '#393939',
                    },
                },
            },
            {
                type: 'value',
                gridIndex: 0,
                min: 50,
                max: 100,
                splitNumber: 8,
                splitLine: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                axisLabel: {
                    show: false,
                },
                splitArea: {
                    show: false,
                    areaStyle: {
                        color: ['rgba(250,250,250,0.0)', 'rgba(250,250,250,0.05)'],
                    },
                },
            },
        ],
        series: [{
                name: legend[0],
                type: 'bar',
                barWidth: 10,
                itemStyle: {
                    normal: {
                        color: ColumnLineColor.columnColor,
                        barBorderRadius: [4, 4, 0, 0],
                    },
                },
                data: y1data,
            },
            {
                name: legend[1],
                type: 'line',
                yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
                showAllSymbol: true, //显示所有图形。
                symbol: 'circle', //标记的图形为实心圆
                symbolSize: 2, //标记的大小
                itemStyle: {
                    //折线拐点标志的样式
                    color: ColumnLineColor.lineColor,
                    borderWidth: '2',
                    borderColor: ColumnLineColor.lineColor,
                },
                lineStyle: {
                    color: ColumnLineColor.lineColor,
                },
                data: y2data,
            },
        ],
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

/**
 * 效果看板  发券人数
 * @param {*} id
 */
const LabelDataAreaLineChart = (id, data) => {
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        dataZoom: [{
            type: 'inside',
            startValue: 0, //可视区域显示的柱状图个数范围
            endValue: 4,
        }, {
            type: 'slider',
            borderColor: 'transparent',
            handleSize: 0,
            bottom: '8%',
            backgroundColor: 'transparent',
            height: '10px',
            zoomLock: true,
            textStyle: {
                color: 'transparent'
            },
            dataBackground: {
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: 'transparent'
                }
            }

        }],
        tooltip: {
            textStyle: {
                color: '#fff'
            },
            padding: [10, 10],
            trigger: 'axis',
            // formatter: (params)=>{
            //     return (params[0].axisValueLabel + '<br/>'+ params[0].seriesName+ ":" +params[0].value)
            // }
            // backgroundColor: '#fff',
            // borderColor: 'rgba(112, 119, 242, 0.8)',
            // borderWidth: 1
        },
        grid: {
            top: '5%',
            left: '3%',
            right: '1%',
            bottom: '0%',
            containLabel: true
        },
        toolbox: {
            show: false
        },

        xAxis: {
            type: 'category',
            data: data.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)',
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: {
                show: false,
                // textStyle: {
                //     color: "rgba(0, 0, 0, 1)"
                // }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
        }],
        series: [{
            name: '发券人数',
            type: 'line',
            data: data.data,
            symbolSize: 4,
            symbol: 'circle',
            smooth: false,
            yAxisIndex: 0,
            label: {
                show: true,
                textStyle: {
                    color: "#000000",
                    fontSize: 10,
                    fontFamily: 'DIN'
                },
                position: "top",
                formatter: function (p) {
                    return p.value > 0 ? (p.value) : '';
                }
            },
            lineStyle: {
                width: 1,
                color: "transparent",
                // shadowColor: '#FBBE02',
                // shadowBlur: 10,
                // shadowOffsetY: 10
            },
            itemStyle: {
                normal: {
                    color: '#000000',
                    // borderColor: '#fff',
                    // borderWidth: 3,
                    // shadowColor: 'rgba(107, 49, 164, 0.7)',
                    // shadowBlur: 5,
                }
            },
            areaStyle: { //区域填充样式
                normal: {
                    color: '#FBBE02',
                    shadowBlur: 0 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                }
            },
        }]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

/**
 * 效果看板  发券人数 横坐标显示间隔数（interval）
 * @param {*} id
 */
 const IntervalLabelDataAreaLineChart = (id, data,interval) => {
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        tooltip: {
            textStyle: {
                color: '#fff'
            },
            padding: [10, 10],
            trigger: 'axis',
        },
        grid: {
            top: '5%',
            left: '3%',
            right: '1%',
            bottom: '0%',
            containLabel: true
        },
        toolbox: {
            show: false
        },

        xAxis: {
            type: 'category',
            data: data.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)',
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval,
                color: '#8A94A6'
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: {
                show: false,
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
        }],
        series: [{
            name: '发券人数',
            type: 'line',
            data: data.data,
            symbolSize: 4,
            symbol: 'circle',
            smooth: false,
            yAxisIndex: 0,
            label: {
                show: true,
                textStyle: {
                    color: "#000000",
                    fontSize: 10,
                    fontFamily: 'DIN'
                },
                position: "top",
                formatter: function (p) {
                    return p.value > 0 ? (p.value) : '';
                }
            },
            lineStyle: {
                width: 1,
                color: "transparent",
            },
            itemStyle: {
                normal: {
                    color: '#000000',
                }
            },
            areaStyle: { //区域填充样式
                normal: {
                    color: HistogramChartsColor,
                    opacity: 1
                    // shadowBlur: 0 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                }
            },
        }]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}


const MarkLineLabelDataAreaLineChart = (id, data, markLineyAxis) => {
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        dataZoom: [{
            type: 'inside',
            startValue: 0, //可视区域显示的柱状图个数范围
            endValue: 4,
        }, {
            type: 'slider',
            borderColor: 'transparent',
            handleSize: 0,
            bottom: '8%',
            backgroundColor: 'transparent',
            height: '10px',
            zoomLock: true,
            textStyle: {
                color: 'transparent'
            },
            dataBackground: {
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: 'transparent'
                }
            }

        }],
        tooltip: {
            textStyle: {
                color: '#fff'
            },
            padding: [10, 10],
            trigger: 'axis',
            // backgroundColor: '#fff',
            // borderColor: 'rgba(112, 119, 242, 0.8)',
            // borderWidth: 1
        },
        grid: {
            top: '10%',
            left: '2%',
            right: '7%',
            bottom: '1%',
            containLabel: true
        },
        toolbox: {
            show: false
        },
        xAxis: {
            type: 'category',
            data: data.legend,
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)',
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: {
                show: false,
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
        }],
        series: [{
            name: '发券人数',
            type: 'line',
            data: data.data,
            symbolSize: 4,
            symbol: 'circle',
            smooth: false,
            yAxisIndex: 0,
            label: {
                show: true,
                textStyle: {
                    color: "#000000",
                    fontSize: 10,
                    fontFamily: 'DIN'
                },
                position: "top",
                formatter: function (p) {
                    return p.value > 0 ? (p.value) : '';
                }
            },
            lineStyle: {
                width: 1,
                color: "transparent",
            },
            itemStyle: {
                normal: {
                    color: '#000000',
                }
            },
            areaStyle: { //区域填充样式
                normal: {
                    color: '#FBBE02',
                    shadowBlur: 0 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                }
            },
            markLine: {
                silent: true,
                symbol : [ 'none', 'none' ],//去掉箭头
                lineStyle : {
                    normal : {
                        type: 'dashed',
                        color : '#0E254D',
                        width : 1
                        // 这儿设置安全基线颜色
                    }
                },
                data : [
                    {
                        yAxis : markLineyAxis,
                        name : 'KPI'
                    }
                ],
                label : {
                    // show: true,
                    // position: 'insideEndTop'
                    normal : {
                        textStyle : {
                            color : '#F84635',
                            fontSize: 9,
                            // fontWeight: 'bold'
                        },
                        formatter: () => {
                            // param.name+ '\n '+ param.value
                            return markLineyAxis
                        }

                    },
                }
            }
        }]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

// 显示 markLineyAxis
// 横坐标显示间隔数（interval）
const IntervalMarkLineLabelDataAreaLineChart = (id, data,markLineyAxis, interval, unit="") => {
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        tooltip: {
            textStyle: {
                color: '#fff'
            },
            padding: [10, 10],
            trigger: 'axis',
        },
        grid: {
            top: '10%',
            left: '2%',
            right: '7%',
            bottom: '1%',
            containLabel: true
        },
        toolbox: {
            show: false
        },
        xAxis: {
            type: 'category',
            data: data.legend,
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)',
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval,
                color: '#8A94A6'
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisTick: { show:false },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
        }],
        series: [{
            name: unit,
            type: 'line',
            data: data.data,
            symbolSize: 4,
            symbol: 'circle',
            smooth: false,
            yAxisIndex: 0,
            label: {
                show: false,
                textStyle: {
                    color: "#000000",
                    fontSize: 10,
                    fontFamily: 'DIN'
                },
                position: "top",
                formatter: function (p) {
                    return p.value > 0 ? (p.value) : '';
                }
            },
            lineStyle: {
                width: 1,
                color: "transparent",
            },
            itemStyle: {
                normal: {
                    color: '#000000',
                }
            },
            areaStyle: { //区域填充样式
                normal: {
                    color: HistogramChartsColor,// HistogramChartsColor
                    opacity: 1,
                    shadowBlur: 0 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                }
            },
            markLine: {
                silent: true,
                symbol : [ 'none', 'none' ],//去掉箭头
                lineStyle : {
                    normal : {
                        type: 'dashed',
                        color : '#0E254D',
                        width : 1
                        // 这儿设置安全基线颜色
                    }
                },
                data : [
                    {
                        yAxis : markLineyAxis,
                        name : 'KPI'
                    }
                ],
                label : {
                    // show: true,
                    // position: 'insideEndTop'
                    normal : {
                        textStyle : {
                            color : '#F84635',
                            fontSize: 9,
                            // fontWeight: 'bold'
                        },
                        formatter: () => {
                            // param.name+ '\n '+ param.value
                            return markLineyAxis
                        }

                    },
                }
            }
        }]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

// 显示 markLineyAxis,x轴倾斜
// 横坐标显示间隔数（interval）; series的name（unit）; 数据的单位（tooltipUnit）;x轴倾斜角度（rotate）;
const RotateIntervalMarkLineLabelDataLineChart = (id, data,markLineyAxis, interval,unit,tooltipUnit,rotate=40) => {
    let myChart = echarts.init(document.getElementById(id))
    let tipUnit = tooltipUnit || ''
    let option = {
        tooltip: {
            textStyle: {
                color: '#fff'
            },
            padding: [10, 10],
            trigger: 'axis',
            formatter: (data) => {
                let dataResult = data[0]
                let result = ''
                if(dataResult.seriesName) {
                    result =  '<div style="line-height: 22px">' + dataResult.name + '</div>' +
                    '<div style="font-weight: bold;line-height: 22px">' + dataResult.seriesName + "：" + util.showThousandNumber(dataResult.value) + tipUnit+'</div>';
                } else {
                    result = '<span style="line-height: 22px">' + data[0].name + '</span>' + "：" +
                    '<span style="font-weight: bold;line-height: 22px">' + dataResult.value + tipUnit+'</span>';
                }
                return result
            }
        },
        grid: {
            top: '10%',
            left: '5%',
            right: '4%',
            bottom: 0,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: data.legend,
            // axisLine: { show: false },
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisTick: { show:false },
            axisLabel: {
                interval,
                color: '#8A94A6',
                rotate
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: { show: false },
            axisLine: { show: false },
            splitLine: { show: false },
            axisTick: { show:false },
        }],
        series: [{
            name: unit,
            type: 'line',
            data: data.data,
            smooth: true,
            yAxisIndex: 0,
            lineStyle: {
                color: HistogramChartsColor,
            },
            itemStyle: {
                // 设置symbol的颜色
                normal: {
                  color: HistogramChartsColor
                }
            },          
            markLine: {
                silent: true,
                symbol : [ 'none', 'none' ],//去掉箭头
                lineStyle : {
                    normal : {
                        type: 'dashed',
                        color : '#ADADAD',
                        width : 2
                        // 这儿设置安全基线颜色
                    }
                },
                data : [
                    {
                        yAxis : markLineyAxis,
                        name : 'KPI',
                        label: {
                        padding: [-13, 10, 5, -45],  // 重点在这里，这个地方就是定位
                          position: 'end',
                        }
                    }
                ],
                label : {
                    // show: true,
                    normal : {
                        textStyle : {
                            color : '#000',
                            fontSize: 12,
                            fontWeight: 'bold'
                        },
                        formatter: () => {
                            // param.name+ '\n '+ param.value
                            return markLineyAxis
                        }

                    },
                }
            }
        }]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    }) 
}

/**
 * 分析比较 多线图
 * @param {*} id
 * @param {*data,legend(x轴数据) } data
 * {
    data: {
    '策略1': [64, 159, 112, 86, 151, 131, 118, 100, 90],
    '策略2': [10, 20, 30, 40, 50, 60, 70, 80, 100],
    },
    legend: ["4/23","4/24","4/25","4/26","4/27","4/28","4/29","4/30","5/01",],
    }
 */
 const MultiLineChart = (id,data) => {
    let lineColor = MultiLineColor.lineColor //线颜色，折线上点的颜色
    let areaStyleColor0 =  MultiLineColor.areaStyleColor0 // 面积0处颜色
    let areaStyleColor1 =  MultiLineColor.areaStyleColor1 // 面积1处颜色
    let seriesList = [] // series值
    let chartData = data.data

    Object.keys(chartData).forEach((item,key)=>{
        let name =  item
        let data = chartData[item]
        seriesList.unshift({
            name: name,
            type: 'line',
            // smooth: true, //是否平滑
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
                normal: {
                    color: lineColor[key], //线的颜色
                },
            },
            itemStyle: {
                color: lineColor[key], // 折线上点的颜色 和线的颜色一致
            },
            areaStyle: { // 面积颜色
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                            offset: 0,
                            color: areaStyleColor0[key],
                        },
                        {
                            offset: 1,
                            color: areaStyleColor1[key],
                        },
                    ]),
                }
            },
            data: data,
        })     
    })
    let myChart = echarts.init(document.getElementById(id))
    let option = {
        dataZoom: [{
            type: 'inside',
            startValue: 0, //可视区域显示的柱状图个数范围
            endValue: 4,
        }, {
            type: 'slider',
            borderColor: 'transparent',
            handleSize: 0,
            bottom: '14%',
            backgroundColor: 'transparent',
            height: '10px',
            zoomLock: true,
            textStyle: {
                color: 'transparent'
            },
            dataBackground: {
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: 'transparent'
                }
            }
        }],
        tooltip: {
            trigger: 'axis',
            textStyle: {
                color: '#fff'
            },
            padding: [10, 10],
            
        },
        legend: {
            top: '0%',
            right: '2%',
        },
        grid: {
            top: '10%',
            left: '2%',
            right: '7%',
            bottom: '8%',
            containLabel: true
        },
        toolbox: {
            show: false
        },
        xAxis: {
            type: 'category',
            data: data.legend,
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)',
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: {
                show: false,
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
        }],
        series: seriesList
        // [
        //     {
        //         name: '示范',
        //         type: 'line',
        //         smooth: true, //是否平滑
        //         symbol: 'circle',
        //         symbolSize: 6,
        //         lineStyle: {
        //             normal: {
        //                 color: 'rgba(252,224,61, 1)', //线的颜色
        //             },
        //         },
        //         itemStyle: {
        //             color: 'rgba(252,224,61, 1)', // 折线上点的颜色 和线的颜色一致
        //         },
        //         areaStyle: { // 面积颜色
        //             normal: {
        //                 color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
        //                     {
        //                         offset: 0.4,
        //                         color: 'rgba(252,224,61, .3)',
        //                     },
        //                     {
        //                         offset: 1,
        //                         color: 'rgba(252,224,61, 1)',
        //                     },
        //                 ]),
        //             }
        //         },
        //         data: [502.84, 205.97, 33.79, 281.55, 398.35, 24.02],
        //     },
        // ]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
 }

/**
 * 分析比较 多柱状图
 * @param {*} id
 * @param {* data, legend(x轴)} result
 * {
    data: {
    '策略1': [64, 159, 112, 86, 151, 131, 118, 100, 90],
    '策略2': [10, 20, 30, 40, 50, 60, 70, 80, 100],
    },
    legend: ["4/23","4/24","4/25","4/26","4/27","4/28","4/29","4/30","5/01",],
    }
 */
 const draggableMultiHistogramCharts = (id, result) => {
    let myChart = echarts.init(document.getElementById(id))
    // let lineColor = ['rgb(255,248,122)', 'rgb(251, 190, 2)','rgb(237,109,0)'] //线颜色，折线上点的颜色
    let lineColor = MultiHistogramColor.lineColor
    let seriesList = [] // series值
    let chartData = result.data
    let legendData = [] //图例
    Object.keys(chartData).forEach((item,key)=>{
        let name = item
        let data = chartData[item]
        legendData.unshift(name)
        seriesList.unshift({
            name: name,
            type: 'bar',
            barWidth: '13',
            color: lineColor[key],
            label: {
                show: false,
                color: '#000',
                position: 'outside',
            },
            itemStyle: {
                normal: {
                  barBorderRadius: [15, 15, 0, 0] // 柱形图圆角
                }
            },
            data: data
        })
    })
    let option = {
        dataZoom: [{
            type: 'inside',
            startValue: 0, //可视区域显示的柱状图个数范围
            endValue: 4,
        }, {
            type: 'slider',
            borderColor: 'transparent',
            handleSize: 0,
            bottom: '14%',
            backgroundColor: 'transparent',
            height: '10px',
            zoomLock: true,
            textStyle: {
                color: 'transparent'
            },
            dataBackground: {
                lineStyle: {
                    color: 'transparent'
                },
                areaStyle: {
                    color: 'transparent'
                }
            }
        }],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: 'rgba(0,0,0,0.05)',
                    borderRadius: '5px',
                }
            },
            // formatter: (data) => {
            //     return '<div style="line-height: 22px">' + data[0].name + '</div>' +
            //         '<div style="font-weight: bold;line-height: 22px">人数：' + util.showThousandNumber(data[0].value) + ' 人</div>';
            // }
        },
        grid: {
            left: '1%',
            right: '3%',
            bottom: '14%',
            top: '15%'
        },
        legend: {
            icon: 'rect',
            top: '-1%',
            right: '2%',
            itemWidth: 12,
            itemHeight: 12,
            data: legendData
        },
        xAxis: [{
            show: true,
            type: 'category',
            data: result.legend,
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLabel: {
                interval: 0,
                color: '#8A94A6'
            },
        }],
        yAxis: {
            show: true,
            type: 'value',
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(241, 242, 244, 1)'
                }
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: 'transparent'
                }
            }
        },
        series: seriesList
        //   [
        //     {
        //         name: '人数',
        //         type: 'bar',
        //         barWidth: '15',
        //         color: 'rgb(255,248,122)',
        //         label: {
        //             show: true,
        //             color: '#000',
        //             position: 'outside',
        //         },
        //         data: [
        //           964,7959,46,451,10,20
        //         ]
        //       },
        // ]
    }
    myChart.setOption(option, true);
    myChart.resize();
    window.addEventListener('resize', function () {
        myChart.resize()
    })
}

export {
    HistogramCharts,
    draggableHistogramCharts,
    RingPieCharts,
    HorizontalHistogramTop4,
    AreaLineChart,
    ColumnLineChart,
    LabelDataAreaLineChart,
    MarkLineHistogramCharts,
    MarkLineLabelDataAreaLineChart,
    MultiLineChart,
    draggableMultiHistogramCharts,
    IntervalLabelDataAreaLineChart,
    IntervalMarkLineLabelDataAreaLineChart,
    IntervalMaxMinHistogramCharts,
    IntervalMaxMinMarkLineHistogramCharts,
    RotateIntervalMarkLineLabelDataLineChart,
}
